<template>
    <div>
        <h3>Daily Most Popular Artists</h3>
        <table id="data" v-if="$store.state.popular_artists">
            <thead>
                <tr>
                    <th>Position</th>
                    <th>Artist</th>
                    <th>Popularity</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, i) in rows" :key="row.identity">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.popularity }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "DataSongs",
    computed: {
        rows() {
            // Get the top artists from the fetched graph
            return this.$store.state.popular_artists.graph
                .filter(d => d.list_index !== -1)
                .sort((b, a) => a.popularity - b.popularity);
        }
    }
};
</script>

<style scoped>
table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    border: 3px solid black;
}

thead th:nth-child(1) {
    width: 20%;
}

thead th:nth-child(2) {
    width: 30%;
}

thead th:nth-child(3) {
    width: 30%;
}

thead th:nth-child(4) {
    width: 20%;
}

th img {
    max-height: 100px;
    width: auto;
}

thead th,
tfoot th,
tfoot td {
    background: rgb(2, 0, 36);
    /*background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(233,52,71,0.9082983535210959) 0%, rgba(12,87,24,1) 0%, rgba(38,248,4,1) 100%);
  text-shadow: 1px 1px 1px white;*/
    color: white;
}

th,
td {
    padding: 20px;
}

tbody tr:nth-child(odd) {
    background-color: #127828;
}

tbody tr:nth-child(even) {
    background-color: #17ad37;
}
</style>
